import React from "react";
import Avatar from "react-avatar";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { normalizeAvatarSrc } from "./avatarUtils";
import { supabase } from "../supabaseClient";
import { NFL_TEAM_LOGOS, MLB_TEAM_LOGOS, NBA_TEAM_LOGOS } from "../Data/teamLogos";

const dropDownScroll = {
  maxHeight: "200px",
  overflow: "scroll",
};

const DisplayName = ({ user }) => {
  return (
    <div className="account-center">
      <h6 className="account-display-name">Display Name: {user.username}</h6>
    </div>
  );
};

const AvatarComponent = ({ user }) => {
  const textSize = {
    fontSize: "100px",
    fontWeight: "bold",
  };
  const avatarSrc = normalizeAvatarSrc(user?.avatar);

  return (
    <div className="account-avatar-row">
      <div className="account-avatar-wrap">
        <Avatar
          round={true}
          size="150"
          name={user.username}
          src={avatarSrc}
          textSize={textSize}
        />
      </div>
      <div className="account-favorite-team-wrap">
        <RenderFavoriteTeam user={user} />
      </div>
    </div>
  );
};

const MyAccEmail = ({ user }) => {
  return <div className="account-center account-info-text">Email: {user.email}</div>;
};

const RenderAboutMe = ({ user }) => {
  if (user.about_me)
    return (
      <div className="account-about-card">
        <div className="account-about-card__title">About</div>
        <div className="account-about-card__body">
          <p>{user.about_me}</p>
        </div>
      </div>
    );
};

const RenderFavoriteTeam = ({ user }) => {
  return (
    <div className="account-center account-info-text">
      {user.favorite_team ? (
        <img
          src={user.favorite_team}
          alt="favorite_Team"
          style={{ width: "100px", height: "100px" }}
        />
      ) : (
        <p>Select team in update account</p>
      )}
    </div>
  );
};
const RenderPhoneNumber=({user})=>{
  return (
    <div className="account-center account-info-text">
      {user.phone_number ? (
<p>{user.phone_number}</p>
      ) : (
        <p>Select team in update account</p>
      )}
    </div>
  );
}
const NavigateToUpdate = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/UpdateMyAccount");
  };
  return (
    <div className="account-center account-update-wrap">
      <button
        type="button"
        onClick={handleButtonClick}
        className="fb-btn fb-btn--ghost"
      >
        Update Account
      </button>
    </div>
  );
};

const MyAccountChanges = ({
  userDetails,
  onUserDetailChange,
  onAvatarFileSelect,
  avatarUploading,
}) => {

  return (
    <>
      <div className="account-form-row">
        <div className="account-form-field">
          <input
            type="text"
            className="auth-input"
            placeholder={userDetails.email}
            onChange={(e) => onUserDetailChange("username", e.target.value)}
            aria-label="Recipient's username"
          />
        </div>
      </div>
      <div className="account-form-row">
        <div className="account-form-field">
          <input
            type="text"
            className="auth-input"
            placeholder={userDetails.username}
            onChange={(e) => onUserDetailChange("email", e.target.value)}
            aria-label="Recipient's email"
          />
        </div>
      </div>
      <div className="account-form-row">
        <div className="account-form-field">
          <input
            type="password"
            className="auth-input"
            placeholder="Password"
            onChange={(e) => onUserDetailChange("password", e.target.value)}
            aria-label="Recipient's password"
          />
        </div>
        
      </div>
      <div className="account-form-row">
        <div className="account-form-field">
          <div className="account-avatar-upload">
            <label className="account-avatar-upload__label" htmlFor="account-avatar-file">
              Upload Avatar Image
            </label>
            <input
              id="account-avatar-file"
              type="file"
              accept="image/png,image/jpeg,image/webp,image/gif"
              className="auth-input account-avatar-upload__input"
              onChange={onAvatarFileSelect}
              aria-label="Upload avatar image"
            />
            <div className="account-avatar-upload__hint">
              {avatarUploading ? "Uploading..." : "PNG, JPG, WEBP, or GIF. Max 3MB recommended."}
            </div>
            <button
              type="button"
              className="fb-btn fb-btn--ghost"
              onClick={() => onUserDetailChange("avatar", "__initials__")}
            >
              Use Initials Avatar
            </button>
          </div>
        </div>
      </div>
      <div className="account-form-row">
        <div className="account-form-field">
          <input
            type="text"
            className="auth-input"
            placeholder="Or paste avatar URL (https://...)"
            value={normalizeAvatarSrc(userDetails.avatar)}
            onChange={(e) => onUserDetailChange("avatar", e.target.value)}
            aria-label="Avatar image URL"
          />
        </div>
      </div>
              <div className="account-form-field account-form-field--center">
          <input
            type="text"
            className="auth-input"
            placeholder={userDetails.phone_number || "Phone Number"}
            onChange={(e) => onUserDetailChange("phone_number", e.target.value)}
            aria-label="Recipient's phone number"
          />
        </div>
      <div className="account-form-row">
        <label className="account-form-field account-form-field--center">
          <input
            type="checkbox"
            checked={Boolean(userDetails.sms_bet_notifications)}
            onChange={(e) => onUserDetailChange("sms_bet_notifications", e.target.checked)}
          />
          Send me an SMS when I receive a bet
        </label>
      </div>
    </>
  );
};

const AboutMeComponent = ({ userDetails, onUserDetailChange }) => {
  return (
    <div className="account-form-row">
      <div className="account-about-editor">
        <textarea
          className="auth-input"
          placeholder={
            userDetails.about_me
              ? userDetails.about_me
              : "Tell us about yourself"
          }
          onChange={(e) => onUserDetailChange("about_me", e.target.value)}
        />
      </div>
    </div>
  );
};

const SPORT_LOGO_SOURCES = {
  NHL: async () => {
    const { data, error } = await supabase.functions.invoke("nhl-standings");
    if (error) throw error;
    return (data?.standings || []).map((team) => team.teamLogo).filter(Boolean);
  },
  // NFL/MLB/NBA logos are static ESPN CDN images (ESPN's team-list API blocks server-side/edge traffic)
  NFL: async () => NFL_TEAM_LOGOS,
  MLB: async () => MLB_TEAM_LOGOS,
  NBA: async () => NBA_TEAM_LOGOS,
};

const UpdateFavTeam = ({ userDetails, onUserDetailChange }) => {
  const [activeSport, setActiveSport] = useState("NHL");
  const [logosBySport, setLogosBySport] = useState({});
  const [loadingSport, setLoadingSport] = useState(null);
  const [errorBySport, setErrorBySport] = useState({});
  const [selectedTeam, setSelectedTeam] = useState(userDetails.favorite_team);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (logosBySport[activeSport]) return;

    let cancelled = false;
    setLoadingSport(activeSport);

    SPORT_LOGO_SOURCES[activeSport]()
      .then((logos) => {
        if (!cancelled) setLogosBySport((prev) => ({ ...prev, [activeSport]: logos }));
      })
      .catch((err) => {
        console.error(`Failed to fetch ${activeSport} logos:`, err);
        if (!cancelled) setErrorBySport((prev) => ({ ...prev, [activeSport]: true }));
      })
      .finally(() => {
        if (!cancelled) setLoadingSport(null);
      });

    return () => {
      cancelled = true;
    };
  }, [activeSport]);

  const handleSelectedTeam = (logo) => {
    onUserDetailChange("favorite_team", logo);
    setSelectedTeam(logo);
    setMenuOpen(false);
  };

  const teamLogos = logosBySport[activeSport] || [];

  return (
    <div className="account-team-picker">
      <div className="d-flex justify-content-center gap-2 mb-2" role="tablist" aria-label="Choose sport">
        {Object.keys(SPORT_LOGO_SOURCES).map((sport) => (
          <button
            key={sport}
            type="button"
            className={`fb-btn ${activeSport === sport ? "fb-btn--primary" : "fb-btn--ghost"}`}
            style={{ padding: "0.4rem 0.9rem", fontSize: "0.85rem" }}
            role="tab"
            aria-selected={activeSport === sport}
            onClick={() => setActiveSport(sport)}
          >
            {sport}
          </button>
        ))}
      </div>

      <div className="account-team-picker__container" role="group">
        <button
          type="button"
          className="fb-btn fb-btn--ghost"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {selectedTeam ? (
            <img
              src={selectedTeam}
              alt="selected_Team"
              style={{ width: "30px", height: "30px" }}
            />
          ) : (
            "Select Favorite Team"
          )}
        </button>

        {menuOpen && (
          <div className="account-team-picker__menu" style={dropDownScroll}>
            {loadingSport === activeSport && <p className="m-2">Loading teams...</p>}
            {errorBySport[activeSport] && (
              <p className="m-2 text-danger">Couldn't load {activeSport} teams. Try again later.</p>
            )}
            {teamLogos.map((logo, index) => (
              <button
                key={index}
                type="button"
                className="account-team-picker__item"
                onClick={() => handleSelectedTeam(logo)}
              >
                <img
                  src={logo}
                  alt={`Team ${index}`}
                  style={{ width: "30px", height: "30px" }}
                />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export {
  AvatarComponent,
  DisplayName,
  MyAccEmail,
  MyAccountChanges,
  AboutMeComponent,
  RenderAboutMe,
  NavigateToUpdate,
  RenderFavoriteTeam,
  UpdateFavTeam,
  RenderPhoneNumber

};
